import { findIndex } from "lodash"
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  open: false,
  description: "",
};

export function MicrocentrifugeReducer(state = { microcentrifuge: [] }, action) {
  let currentMicrocentrifuge;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_MICROCENTRIFUGE" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
        if(state.protocolSection.scene.apparatus.hasOwnProperty("microcentrifuge")){
          currentMicrocentrifuge = state.protocolSection.scene.apparatus.microcentrifuge[findIndex(state.protocolSection.scene.apparatus.microcentrifuge, { id: action.payload.id })]
        }
      }
  }

  switch (action.type) {

        case 'CREATE_MICROCENTRIFUGE':

          //Create new obj from template state
          let newObj = { ...templateState, ...action.payload.props }

          if(protocolSection.scene.apparatus.hasOwnProperty("microcentrifuge")){
            protocolSection.scene.apparatus.microcentrifuge = [ ...protocolSection.scene.apparatus.microcentrifuge, newObj ]
          } else {
            protocolSection.scene.apparatus.microcentrifuge = [newObj]
          }

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case 'MICROCENTRIFUGE_OPEN':

            // xAPI statement
            // sendxAPI({
            //   // Type of statement
            //   verb: {
            //     description: (action.payload.open)?"opened":"closed",
            //     address: (action.payload.open)?"https://w3id.org/xapi/dod-isd/verbs/opened":"https://w3id.org/xapi/dod-isd/verbs/closed"
            //   },
            //   // Where the action occured
            //   context: currentMicrocentrifuge.type + " Microcentrifuge",
            //   // Result of the action
            //   result: {
            //     success: true,
            //     response: action.payload.open
            //   }
            // })

            currentMicrocentrifuge.open = action.payload.open
            protocolSection.scene.apparatus.microcentrifuge[findIndex(state.microcentrifuge, { id: action.payload.id })] = currentMicrocentrifuge

            return { ...state, ...{
              protocolSection: protocolSection
            } }

          // case "UNDO":
          //     //Payload = {lastState}
          //
          //     if (action.payload.lastState !== null) {
          //
          //       protocolSection.scene.apparatus.microcentrifuge = action.payload.lastState.scene.apparatus.microcentrifuge
          //
          //       return { ...state, ...{
          //         protocolSection: protocolSection
          //       } }
          //
          //     } else {
          //       return state;
          //     }

        default:
            return state;
    }
}
